import React from "react";
import { Container } from "react-bootstrap";
import "./Fifth.css";
import first from "../../../../Asset/fifth-logistic-first.svg";
import second from "../../../../Asset/fifth-logistic-2.svg";
import third from "../../../../Asset/fifth-logistic-3.svg";
import fourth from "../../../../Asset/fifth-logistic-4.svg";

const serviceData = [
  {
    img: first,
    title: "Supply Chain Visibility Platforms",
    description:
      "Gain end-to-end visibility into your supply chain for improved coordination and efficiency.",
  },
  {
    img: second,
    title: "Intelligent Warehouse Management",
    description:
      "Optimize inventory, automate picking, and streamline warehouse operations with smart systems.",
  },
  {
    img: third,
    title: "AI-Powered Route Optimization",
    description:
      "Minimize costs and delivery times with machine learning algorithms for route planning.",
  },
  {
    img: fourth,
    title: "Blockchain for Logistics/Shipping",
    description:
      "Enhance transparency, traceability, and security in your supply chain with blockchain technology.",
  },
];

const Fifth = () => {
  return (
    <>
      <section className="fifth-logistic-section">
        <Container>
          <div className="title-section text-center">
            <h2 className="store-success-title">
              Our IT Services for
              <strong> Logistics & Shipping</strong>
            </h2>
          </div>
          <div className="models_cards_warp">
            <div className="row models_row">
              {serviceData.map((service, index) => (
                <div
                  key={index}
                  className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12"
                >
                  <div className="models_boxs">
                    <div className="image_part">
                      <img
                        src={service.img}
                        alt="box"
                        className="w-100 h-100 object-fit-cover"
                      />
                    </div>
                    <div className="content_part">
                      <h3>{service.title}</h3>
                      <p>{service.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Fifth;
